// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__3oLz2","Clickable":"Card_Clickable__C5pHb"};